module.exports = __webpack_public_path__ + "img/banner1.a4fe0078.png";